import { defineStore } from 'pinia';

export const useDeviceStore = defineStore('deviceStore', {
  state: () => ({
    isMobile: false,
    isTablet: false,
    isDesktop: false,
    screenWidth: window.innerWidth,
    screenHeight: window.innerHeight,
  }),
  actions: {
    detectDevice() {
      this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;

      // Define breakpoints for device types
      const mobileBreakpoint = 768; // Example: devices with width <= 768px are mobile
      const tabletBreakpoint = 1024; // Example: devices with width <= 1024px are tablets

      this.isMobile = this.screenWidth <= mobileBreakpoint;
      this.isTablet = this.screenWidth > mobileBreakpoint && this.screenWidth <= tabletBreakpoint;
      this.isDesktop = this.screenWidth > tabletBreakpoint;
    },
  },
  getters: {
    deviceType: (state) => {
      if (state.isMobile) return 'mobile';
      if (state.isTablet) return 'tablet';
      return 'desktop';
    },
  },
});